import { render, staticRenderFns } from "./tab-canceled.vue?vue&type=template&id=7a8efe8a"
import script from "./tab-canceled.vue?vue&type=script&lang=js"
export * from "./tab-canceled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports